import * as types from '../types';
import { VenueManagementAction, NAVIGATE_TO, SET_ACTIVE_ITEM_TOUCHED } from '../actions/venue-management';
import { ActiveItem } from '../components/venue-management/types';

export default function reduce(
    state: types.VenueManagementState = {
        activeItem: ActiveItem.GENERAL,
        activeItemTouched: false,
    },
    action: VenueManagementAction
) {
    switch (action.type) {
        case NAVIGATE_TO:
            return {
                ...state,
                activeItem: action.payload,
            };
        case SET_ACTIVE_ITEM_TOUCHED:
            return {
                ...state,
                activeItemTouched: action.payload,
            };
        default:
            return { ...state };
    }
}
